import { render } from "./NamePickPopup.vue?vue&type=template&id=48eefa0a&scoped=true"
import script from "./NamePickPopup.vue?vue&type=script&lang=js"
export * from "./NamePickPopup.vue?vue&type=script&lang=js"

import "./NamePickPopup.vue?vue&type=style&index=0&id=48eefa0a&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48eefa0a"]])

export default __exports__